import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authModel } from '../../../entities/auth-operation';
import { redirectActions } from '../../../entities/history';
import { IconMap } from '../../../shared/sprite';
import { Avatar, Icon } from '../../../shared/ui';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { authUserModel } from '../../../entities/auth-user';
import { SETTINGS_PROFILE_ROUTE } from '../../../entities/history';
import { cn } from '@distribute/frontend/utils';

type ProfileDropdownProps = {
  onContactSupport: () => void;
};

export const ProfileDropdown: React.FC<ProfileDropdownProps> = ({
  onContactSupport,
}) => {
  const { displayName, email, photoUrl } = useSelector(
    authUserModel.selectors.selectUserWithError
  );

  const dispatch = useDispatch();

  const options = [
    {
      id: 'Settings',
      label: 'Profile settings',
      onClick: () => {
        dispatch(
          redirectActions.fromWorkspaceWithBackUrl({
            path: SETTINGS_PROFILE_ROUTE,
          })
        );
      },
      iconName: IconMap.Settings01,
      iconWidth: 16,
      className: 'md:hidden',
    },
    {
      id: 'Help',
      label: 'Help',
      onClick: onContactSupport,
      iconName: IconMap.HelpCircle,
      iconWidth: 16,
    },
    {
      id: 'LogOut',
      label: 'Log out',
      onClick: () => dispatch(authModel.actions.signOutClick()),
      iconName: IconMap.Logout,
      iconWidth: 16,
      isSeparatedFromTop: true,
    },
  ];

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="outline-none focus:outline-none">
        <Avatar
          displayName={displayName}
          src={photoUrl}
          isUserAvatar
          className="border border-base-black/[0.08] w-8 h-8"
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        sideOffset={4}
        align="end"
        className="flex flex-col gap-1 border rounded-lg bg-base-white border-gray-200 focus:outline-none overflow-hidden px-1.5 py-1 z-10 shadow-lg w-60"
      >
        <div className="flex flex-row gap-x-3 md:px-2.5 px-4 py-3">
          <Avatar
            displayName={displayName}
            src={photoUrl}
            isUserAvatar
            className="border border-base-black/[0.08]"
          />
          <div className="w-full truncate">
            <p className="font-semibold text-s text-gray-700 truncate">
              {displayName}
            </p>
            <p className="text-gray-700 text-s truncate">{email}</p>
          </div>
        </div>
        {options.map((item) => (
          <>
            {item.isSeparatedFromTop && (
              <div key={item.id + '-'} className="-mx-1.5 h-0.25 bg-gray-200" />
            )}
            <DropdownMenu.Item
              key={item.id}
              onSelect={item.onClick}
              className={cn(
                'group outline-none px-2.5 py-2.5 text-sm font-medium text-gray-700 hover:text-gray-900 flex flex-nowrap items-center gap-2 hover:bg-base-black/[0.04] focus:bg-base-black/[0.04] rounded-md cursor-pointer',
                item.className
              )}
            >
              <Icon
                glyph={item.iconName}
                width={item.iconWidth}
                className="flex-shrink-0 text-gray-600 group-hover:text-gray-700"
              />
              {item.label}
            </DropdownMenu.Item>
          </>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
